










import Vue from 'vue';
import { BFormInput } from 'bootstrap-vue';

import RichText from '@/components/rich_text/RichText.vue';

export default Vue.extend({
  name: 'EditCardText',
  components: {
    BFormInput,
    RichText,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    subtype: {
      type: String,
      default: 'plain',
    },
  },
});
